import React, { Fragment } from 'react';
import cx from 'classnames';
import styled from 'styled-components';
import { stacked } from 'app/shared/styles/_spacing';

import Text from 'app/shared/core/Text';
import Title from 'app/shared/modules/Title';

import map from 'lodash/map';
import isEqual from 'lodash/isEqual';

import './style.scss';

const StyledText = styled(Text)`
  ${stacked._1x};
`;
const StyledSection = styled.section`
  ${stacked._1x};
`;
const StyledTitle = styled(Title)`
  ${stacked._xs};
`;

type Question = {
  question: string;
  answer: string | Array<string>;
  answerType?: 'answer' | 'unorderedList' | 'orderedList';
  listHeader?: string;
};

type Props = {
  data?: Array<Question>;
  wrapper?: React.ComponentType<{ children: React.ReactNode }> | typeof Fragment;
  [key: string]: unknown;
};

class FaqSection extends React.Component<Props> {
  static defaultProps = {
    data: [],
    wrapper: Fragment,
  };

  shouldComponentUpdate(nextProps: Props): boolean {
    const { data } = this.props;

    if (isEqual(data, nextProps.data)) {
      return false;
    }

    return true;
  }

  renderStandardAnswer = (question: Question): JSX.Element => {
    return <Text>{question.answer}</Text>;
  };

  renderListedAnswer = (question: Question): JSX.Element => {
    const answerType = question.answerType;
    const ListElement = answerType === 'unorderedList' ? 'ul' : 'ol';

    return (
      <Fragment>
        {question.listHeader && <StyledText htmlTag="p">{question.listHeader}</StyledText>}
        <ListElement className={cx(ListElement === 'ul' ? 'AreaFaq-unordered-list' : 'AreaFaq-ordered-list')}>
          {Array.isArray(question.answer) &&
            question.answer.length &&
            question.answer.map((answer, idx) => {
              return <li key={`answer-${idx}-${answer}`}>{answer}</li>;
            })}
        </ListElement>
      </Fragment>
    );
  };

  renderFaqSection = (data: Array<Question>): Array<JSX.Element> => {
    return map(data, (question) => {
      const answerType = question.answerType;
      return (
        <StyledSection key={`question-id-${question.question}`}>
          <StyledTitle size="md" htmlTag="h3">
            {question.question}
          </StyledTitle>
          {answerType === 'answer' && this.renderStandardAnswer(question)}
          {(answerType === 'unorderedList' || answerType === 'orderedList') && this.renderListedAnswer(question)}
        </StyledSection>
      );
    });
  };

  render(): React.ReactNode {
    const { wrapper, data = [], ...wrapperProps } = this.props;
    const Wrapper = wrapper as React.ComponentType<{ children: React.ReactNode } & Record<string, unknown>>;

    return (
      <article className="AreaFaq">
        <Wrapper {...wrapperProps}>{this.renderFaqSection(data)}</Wrapper>
      </article>
    );
  }
}

export default FaqSection;
